(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Ventamesdia', Ventamesdia)
		.factory('VentamesdiaFecha', VentamesdiaFecha); 

    Ventamesdia.$inject = ['$resource', 'DateUtils'];
	VentamesdiaFecha.$inject = ['$resource', 'DateUtils'];

	
    function Ventamesdia ($resource, DateUtils) {
        var resourceUrl =  'api/ventamesdias/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fecha = DateUtils.convertDateTimeFromServer(data.fecha);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
	
	function VentamesdiaFecha ($resource, DateUtils) {
		var resourceUrl =  'api/ventasmesdiasfecha';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
				params: {fromDate: null, toDate: null},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fecha = DateUtils.convertDateTimeFromServer(data.fecha);
						//data.total = data.total / 1.21;
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
	}
})();
